// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@awc/App/Store/Reducers";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    canCheckoutWithCart,
    hasOnlyQuoteRequiredProducts,
    isCartCheckoutDisabled,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export const xIsAuthenticated = (state: ApplicationState): boolean => {
    const session = getSession(state);
    return session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
};

export const xisCheckoutDisabled = (cart: Cart | undefined) => {
    return !canCheckoutWithCart(cart) || hasOnlyQuoteRequiredProducts(cart) || isCartCheckoutDisabled(cart);
};

export const xIsDesktopScreenSize = (state: CustomAppState) => {
    const { isTabletScreen } = state.xCommon;
    return !isTabletScreen;
};

// export function xGetIsProductCompareFull(state: CustomAppState) {
//     return state.components.compareProductsDrawer.productsIds.length >= state.xMaxProductsToCompare.maxProducts;
// }

export const xIsPLPTableView = (state: CustomAppState) => {
    const isTableView = state.pages.productList.view?.toLowerCase() === "table";
    const isPLPBreakpoint = state.xCommon.isPLPBreakpoint;
    return isTableView || isPLPBreakpoint;
};
